import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PropertyProviderModel } from '../models/property-provider.model';
import { PropertyProvidersService } from '../services/property-providers.service';

@Injectable()
export class PropertyProvidersResolver implements Resolve<Array<PropertyProviderModel>> {

    constructor(private service: PropertyProvidersService) 
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<Array<PropertyProviderModel>> {
        return this.service.GetPropertyProviders();
    }
}
